import { Component } from '@angular/core'

@Component({
  selector: 'lin-dashboard-card-list',
  template: ` <ng-content></ng-content> `,
  styleUrls: [`./dashboard-card-list.component.scss`],
  standalone: false,
})
export class DashboardCardListComponent {}
